// @flow
import React from "react";
import { colors } from "src/styles/constants";

const svgs = {
  files: (
    <g>
      <path d="M2.344.502h10.312M10.781 6.529v2.009H4.22V6.529" />
      <path d="M.469 3.516h14.063v11.049H.469z" />
    </g>
  ),

  down: (
    <g>
      <path fill={colors.black} fillRule="nonzero" d="M8 0L4 4 0 0z" />
    </g>
  ),

  add: (
    <g transform="translate(-4 -4)" fill={colors.pureWhite}>
      <path d="M19 13h-6v6h-2v-6h-6v-2h6v-6h2v6h6v2z" />
    </g>
  ),

  notification: (
    <g>
      <path d="M10.375 13.656a1.874 1.874 0 1 1-3.75 0M1.469 11.781H15.53M14.594 11.781h.469c-1.036 0-2.344-.839-2.344-1.875V5.687a4.22 4.22 0 0 0-8.438 0v4.22c0 1.035-.839 1.874-1.875 1.874" />
    </g>
  ),

  question: (
    <g>
      <circle cx="7.5" cy="7.5" r="7" />
      <circle cx="7.5" cy="12" r="1" />
      <path d="M6 3.577c.953-.86 3.018-.845 3.423.635C9.95 6.134 7.5 6.142 7.5 9" />
    </g>
  ),

  call: (
    <g transform="translate(0 4)">
      <path d="M10.167 7.833L8.5 9.5l-5-5 1.667-1.667-2.5-2.5L1 2c0 5.523 4.477 10 10 10l1.667-1.667-2.5-2.5zM13.778.182L16 1.09v-3.182l-2.222.91" />
      <path d="M13.333 2H9.778a.45.45 0 0 1-.445-.455v-4.09c0-.251.2-.455.445-.455h3.555a.45.45 0 0 1 .445.455v4.09c0 .251-.2.455-.445.455z" />
    </g>
  ),

  search: (
    <g>
      <path d="M15.5 14h-.79l-.28-.27c.98-1.14 1.57-2.62 1.57-4.23 0-3.59-2.91-6.5-6.5-6.5s-6.5 2.91-6.5 6.5 2.91 6.5 6.5 6.5c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99 1.49-1.49-4.99-5zm-6 0c-2.49 0-4.5-2.01-4.5-4.5s2.01-4.5 4.5-4.5 4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5z" />
    </g>
  ),

  searchBox: (
    <g>
      <circle cx="7.5" cy="7.5" r="4.125" />
      <path d="M15 15l-4.125-4.125M7.5 15H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h9a3 3 0 0 1 3 3v4.5" />
    </g>
  ),

  group: (
    <g fill="none" fillRule="nonzero" stroke="#979797">
      <path d="M15 15.5C15 7.492 8.508 1 .5 1M12 15.5C12 9.149 6.851 4 .5 4M9 15.5A8.5 8.5 0 0 0 .5 7M6 15.5A5.5 5.5 0 0 0 .5 10" />
    </g>
  ),

  conversation: (
    <g transform="translate(1 1)">
      <path d="M17.6 16v-1.3c0-2.15-2.066-3.93-4.754-4.246M11.2 16v-1.3c0-2.371-2.512-4.3-5.6-4.3-3.088 0-5.6 1.929-5.6 4.3V16M11.396 7.138c.197.034.397.062.604.062 1.985 0 3.6-1.615 3.6-3.6S13.985 0 12 0c-.207 0-.407.027-.605.062" />
      <circle cx="5.6" cy="3.6" r="3.6" />
    </g>
  ),

  approval: (
    <g>
      <path d="M.5 5.5v-5h5M14.5 5.5v-5h-5" />
      <path d="M.5.5l7 7v8M14.5.5l-5 5" />
    </g>
  ),

  approvals: (
    <g>
      <path d="M.5 5.5v-5h5M14.5 5.5v-5h-5" />
      <path d="M.5.5l7 7v8M14.5.5l-5 5" />
    </g>
  ),

  decision: (
    <g>
      <path d="M.5 5.5v-5h5M14.5 5.5v-5h-5" />
      <path d="M.5.5l7 7v8M14.5.5l-5 5" />
    </g>
  ),

  decisions: (
    <g>
      <path d="M.5 5.5v-5h5M14.5 5.5v-5h-5" />
      <path d="M.5.5l7 7v8M14.5.5l-5 5" />
    </g>
  ),

  favourites: (
    <g>
      <path d="M7.031 0l2.173 4.402 4.858.706-3.515 3.427.83 4.84L7.03 11.09l-4.345 2.284.83-4.839L0 5.108l4.858-.706z" />
    </g>
  ),

  solidFavourites: (
    <g>
      <path
        fill="#2E4C68"
        stroke="#2E4C68"
        d="M7.031 0l2.173 4.402 4.858.706-3.515 3.427.83 4.84L7.03 11.09l-4.345 2.284.83-4.839L0 5.108l4.858-.706z"
      />
    </g>
  ),

  workflows: (
    <g>
      <path d="M3.5 7.5h11M11 4l3.5 3.5L11 11M.5.5v14M6.5.5v4M6.5 10.5v4" />
    </g>
  ),

  workflow: (
    <g>
      <path d="M3.5 7.5h11M11 4l3.5 3.5L11 11M.5.5v14M6.5.5v4M6.5 10.5v4" />
    </g>
  ),

  task: (
    <g>
      <path d="M11.5 1.5h1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-12a1 1 0 0 1 1-1h1" />
      <path d="M4.5.5h5v2h-5zM4 9l2 2 4-4" />
    </g>
  ),

  tasks: (
    <g>
      <path d="M11.5 1.5h1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-12a1 1 0 0 1 1-1h1" />
      <path d="M4.5.5h5v2h-5zM4 9l2 2 4-4" />
    </g>
  ),

  chat: (
    <g>
      <path
        fill="none"
        fillRule="evenodd"
        stroke="#888"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M1 1.8a.8.8 0 0 1 .8-.8h10.4a.8.8 0 0 1 .8.8V9a.8.8 0 0 1-.8.8H7.934L4.2 13V9.8H1.8A.8.8 0 0 1 1 9V1.8z"
      />
    </g>
  ),

  directmessages: (
    <g>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M6.638 11.404H2.553c-1.157 0-2.042.885-2.042 2.043v2.042h8.17v-2.042c0-1.158-.885-2.043-2.043-2.043zM4.596 9.362c-1.158 0-2.043-.886-2.043-2.043v-.68c0-1.158.885-2.043 2.043-2.043 1.157 0 2.042.885 2.042 2.042v.681c0 1.157-.885 2.043-2.042 2.043zM8.68.51V7.32l2.724-2.043h4.085V.511H8.681z"
      />
    </g>
  ),

  everything: (
    <g width="16" height="16">
      <path
        fill="#ACBBC9"
        fillRule="nonzero"
        d="M8 0C3.589 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zM1.025 8.5H3.23c.038 1.077.198 2.088.458 3h-1.74a6.933 6.933 0 0 1-.922-3zm7.475-5V1.071c.936.242 1.775 1.138 2.371 2.429H8.5zm2.756 1c.289.9.471 1.919.516 3H8.5v-3h2.756zM7.5 1.071V3.5H5.129C5.725 2.21 6.564 1.312 7.5 1.071zm0 3.429v3H4.228c.044-1.081.227-2.1.516-3H7.5zm-4.271 3H1.025a6.94 6.94 0 0 1 .922-3h1.74c-.26.912-.42 1.923-.458 3zm1 1H7.5v3H4.744c-.289-.9-.472-1.919-.516-3zm3.271 4v2.429c-.936-.241-1.775-1.138-2.371-2.429H7.5zm1 2.429V12.5h2.371c-.596 1.29-1.435 2.188-2.371 2.429zm0-3.429v-3h3.272a11.365 11.365 0 0 1-.516 3H8.5zm4.271-3h2.204a6.94 6.94 0 0 1-.922 3h-1.74c.26-.912.42-1.923.458-3zm0-1a12.605 12.605 0 0 0-.458-3h1.74a6.94 6.94 0 0 1 .922 3H12.77zm.583-4H11.98a7.626 7.626 0 0 0-1.038-1.843A7.028 7.028 0 0 1 13.354 3.5zM5.058 1.657A7.626 7.626 0 0 0 4.02 3.5H2.646a7.028 7.028 0 0 1 2.412-1.843zM2.646 12.5H4.02a7.626 7.626 0 0 0 1.038 1.843A7.028 7.028 0 0 1 2.646 12.5zm8.296 1.843A7.609 7.609 0 0 0 11.98 12.5h1.374a7.028 7.028 0 0 1-2.412 1.843z"
      />
    </g>
  ),

  myconversations: (
    <g>
      <path d="M10.844 1.469H2.406a.938.938 0 0 0-.937.937v5.625c0 .518.42.938.937.938h1.875v2.812L7.094 8.97h3.75c.517 0 .937-.42.937-.938V2.406a.938.938 0 0 0-.937-.937z" />
      <path d="M7.094 12.719h2.812l2.813 2.812V12.72h1.875c.517 0 .937-.42.937-.938V6.156a.938.938 0 0 0-.937-.937h-.938" />
    </g>
  ),

  funnel: (
    <g transform="translate(-488 -106)">
      <path d="M489 107h14.063l-5.625 7.5v5.625h-2.813V114.5z" />
    </g>
  ),

  close: (
    <g>
      <path d="M11.5.5l-11 11M.5.5l11 11" />
    </g>
  ),

  globe: (
    <g>
      <path d="M11.99 2c-5.52 0-9.99 4.48-9.99 10s4.47 10 9.99 10c5.53 0 10.01-4.48 10.01-10s-4.48-10-10.01-10zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zm-6.92-3.96c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zm-7.74 9.96c-.16-.64-.26-1.31-.26-2s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2h-3.38zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8h-2.95c.96-1.66 2.49-2.93 4.33-3.56-.6 1.11-1.06 2.31-1.38 3.56zm3.97 11.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zm2.34-5.96h-4.68c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zm1.77-5.56c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z" />
    </g>
  ),

  myemail: (
    <g>
      <path d="M14.5 13.833h-13a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1z" />
      <path d="M2.5 3.833l5.5 4.5 5.5-4.5" />
    </g>
  ),

  feed: (
    <g fill="none" fillRule="nonzero" stroke="#979797">
      <path d="M15 15.5C15 7.492 8.508 1 .5 1M12 15.5C12 9.149 6.851 4 .5 4M9 15.5A8.5 8.5 0 0 0 .5 7M6 15.5A5.5 5.5 0 0 0 .5 10" />
    </g>
  ),

  pin: (
    <g>
      <path d="M1.469 5.156l9.375 9.375M9.906.469l5.625 5.625M3.012 6.7l8.435-4.69M9.3 12.988l4.69-8.435M4.75 11.25l-3.281 3.281" />
    </g>
  ),

  recent: (
    <g fill={colors.darkGrey} strokeWidth="0.2">
      <path d="M8.478 3.26a.652.652 0 0 0-.652.653v2.609c0 .36.292.652.652.652h2.609a.652.652 0 1 0 0-1.304H9.13V3.913a.652.652 0 0 0-.652-.652zm0-3.26a6.53 6.53 0 0 0-6.522 6.522v.382l-.843-.843a.652.652 0 1 0-.922.922l1.956 1.956a.659.659 0 0 0 .462.191c.173 0 .339-.07.461-.191l1.956-1.956a.652.652 0 0 0-.922-.922l-.843.843v-.382a5.223 5.223 0 0 1 5.217-5.218 5.223 5.223 0 0 1 5.218 5.218 5.223 5.223 0 0 1-5.218 5.217.652.652 0 0 0 0 1.304A6.53 6.53 0 0 0 15 6.522 6.53 6.53 0 0 0 8.478 0z" />
    </g>
  ),

  contact: (
    <g>
      <circle cx="7.357" cy="5.625" r="2.344" />
      <path d="M12.49 14.531a5.156 5.156 0 0 0-10.266 0" />
      <rect width="14.063" height="14.063" x=".326" y=".469" rx="1" />
    </g>
  ),

  mail: (
    <g>
      <path d="M14.5 13.833h-13a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1z" />
      <path d="M2.5 3.833l5.5 4.5 5.5-4.5" />
    </g>
  ),

  settings: (
    <g>
      <circle cx="8" cy="8" r="2.5" />
      <path d="M13.5 8c0-.465-.064-.913-.172-1.344l1.917-1.107-1.5-2.598-1.915 1.106A5.476 5.476 0 0 0 9.5 2.713V.5h-3v2.212a5.5 5.5 0 0 0-2.33 1.345L2.255 2.951l-1.5 2.598 1.917 1.107A5.512 5.512 0 0 0 2.5 8c0 .464.064.913.172 1.344L.755 10.451l1.5 2.598 1.916-1.106a5.476 5.476 0 0 0 2.33 1.344V15.5h3v-2.212a5.503 5.503 0 0 0 2.33-1.344l1.916 1.106 1.5-2.598-1.917-1.107c.106-.432.17-.881.17-1.345z" />
    </g>
  ),

  plus: (
    <g>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M0 8.84h8.024V0h2.363v8.84h8.024v2.28h-8.024V20H8.024v-8.88H0z"
      />
    </g>
  ),

  checklist: (
    <g>
      <path d="M.469.5h1.875M.469 4.5h1.875M.469 8.5h1.875M.469 12.5h1.875M5.156.5h9.375M5.156 4.5h5.625M5.156 8.5h9.375M5.156 12.5h4.688" />
    </g>
  ),

  pc: (
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#6F6F6F"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M.5 10.5h15M2.5.5h11v8h-11z" />
    </g>
  ),

  ellipsis: (
    <g fill="#888" fillRule="evenodd">
      <path d="M2 4C.893 4 0 3.107 0 2s.893-2 2-2 2 .893 2 2-.893 2-2 2zM8 4c-1.107 0-2-.893-2-2s.893-2 2-2 2 .893 2 2-.893 2-2 2zM14 4c-1.107 0-2-.893-2-2s.893-2 2-2 2 .893 2 2-.893 2-2 2z" />
    </g>
  ),

  incomplete: (
    <g>
      <circle cx="8" cy="8" r="7.5" />
      <path d="M4.5 7.5L7 10l5-5" />
    </g>
  ),

  completed: (
    <g>
      <circle cx="8" cy="8" r="7.5" fill="#0ABC8A" stroke="#0ABC8A" />
      <path stroke="#FFF" d="M4.5 7.5L7 10l5-5" />
    </g>
  ),

  rejected: (
    <g>
      <circle cx="8" cy="8" r="7.467" fill="#E53D01" stroke="#E53D01" />
      <path stroke="#FFF" d="M11.2 4.8l-6.4 6.4M4.8 4.8l6.4 6.4" />
    </g>
  ),

  dateCompleted: (
    <g strokeWidth=".857" transform="translate(.5 1)">
      <circle cx="6" cy="6" r="6" fill="#E53D01" stroke="#E53D01" />
      <path stroke="#FFF" d="M6 2.571V6h3.429" />
    </g>
  ),

  dateWarning: (
    <g stroke="#E53D01" strokeWidth=".857" transform="translate(.5 1)">
      <circle cx="6" cy="6" r="6" />
      <path d="M6 2.571V6h3.429" />
    </g>
  ),

  date: (
    <g>
      <path
        fill="#BBB"
        stroke="#BBB"
        strokeWidth=".3"
        d="M8.33 1A7.335 7.335 0 0 0 1 8.33a7.335 7.335 0 0 0 7.33 7.33 7.335 7.335 0 0 0 7.33-7.33A7.335 7.335 0 0 0 8.33 1zm0 .682a6.643 6.643 0 0 1 6.647 6.648 6.643 6.643 0 0 1-6.647 6.647A6.643 6.643 0 0 1 1.682 8.33 6.643 6.643 0 0 1 8.33 1.682zm0 1.363a.34.34 0 0 0-.341.341V8.33c0 .126.068.234.17.293l3.984 2.3c.164.095.375.041.47-.122a.34.34 0 0 0-.129-.463L8.67 8.132V3.386a.34.34 0 0 0-.34-.34z"
      />
    </g>
  ),

  hamberger: (
    <g>
      <path d="M.5.5h14M.5 6.5h14M.5 12.5h14" />
    </g>
  ),

  direct: (
    <g>
      <circle cx="8" cy="6" r="2.5" />
      <path d="M12.953 13.621a5.491 5.491 0 0 0-9.906 0" />
      <circle cx="8" cy="8" r="7.5" />
    </g>
  ),

  reply: (
    <g>
      <path d="M0 7l7-6v4.033c3.781 0 8 1.467 8 7.967-1.969-3.188-5-4-8-4v4L0 7z" />
    </g>
  ),

  forward: (
    <g>
      <path d="M7.5.5l8 6.5-8 6.5v-4H3a2.5 2.5 0 1 1 0-5h4.5v-4z" />
    </g>
  ),

  unifize: (
    <g fill="#FFF">
      <path
        stroke="#FFF"
        strokeWidth="0.2"
        d="M.9 1.322a.853.853 0 0 0-.862.844v3.957c0 1.122.468 2.141 1.222 2.88a4.197 4.197 0 0 0 2.942 1.196 4.197 4.197 0 0 0 2.941-1.197 4.02 4.02 0 0 0 1.223-2.879V4.696a.853.853 0 0 0-.862-.843.853.853 0 0 0-.862.843v1.427c0 .656-.275 1.253-.717 1.687a2.459 2.459 0 0 1-1.723.702c-.67 0-1.28-.269-1.723-.702a2.356 2.356 0 0 1-.718-1.687v-3.26h.423a.781.781 0 0 0 .787-.77.781.781 0 0 0-.787-.77H.9z"
      />

      <path
        stroke="#FFF"
        strokeWidth="0.2"
        d="M4.562 1.817a4.02 4.02 0 0 0-1.222 2.88v1.426c0 .466.386.844.862.844a.853.853 0 0 0 .862-.844V4.696c0-.656.274-1.253.717-1.686a2.46 2.46 0 0 1 1.723-.702c.67 0 1.28.268 1.723.702.442.433.717 1.03.717 1.686v3.26h-.422a.781.781 0 0 0-.787.77c0 .424.354.771.787.771h1.284a.853.853 0 0 0 .862-.843V4.696a4.02 4.02 0 0 0-1.223-2.879A4.198 4.198 0 0 0 7.504.621a4.197 4.197 0 0 0-2.942 1.196"
      />
    </g>
  ),

  image: (
    <g>
      <path fill="#D04423" d="M1 1h11.049v5.071H17V21H1z" />
      <path stroke="#FFF" strokeWidth="1.34" d="M11.667 1v5.333H17" />
      <path
        stroke="#D04423"
        strokeLinecap="square"
        strokeWidth="1.34"
        d="M17 9V6.333L11.667 1H1v8"
      />

      <path
        stroke="#D04423"
        strokeLinecap="square"
        strokeWidth="1.34"
        d="M1 8.333V21h16V8.333"
      />

      <path
        stroke="#F5F6F7"
        fill="#F5F6F7"
        strokeWidth="0.2"
        d="M6.89 14.68c0 .203-.025.388-.076.555-.051.167-.128.31-.23.429-.103.119-.231.211-.386.277a1.393 1.393 0 0 1-.548.099 2.615 2.615 0 0 1-.57-.065l.045-.493a.16.16 0 0 1 .053-.105.186.186 0 0 1 .127-.04c.028 0 .063.005.105.014.042.01.092.014.15.014a.615.615 0 0 0 .214-.034.331.331 0 0 0 .151-.112.542.542 0 0 0 .09-.207c.02-.085.03-.19.03-.315v-2.34h.845v2.323zm1.955-.535c.22 0 .378-.052.475-.157.097-.106.145-.252.145-.44a.658.658 0 0 0-.037-.228.463.463 0 0 0-.307-.29.851.851 0 0 0-.276-.04h-.44v1.155h.44zm0-1.787c.257 0 .477.03.661.09.184.062.336.145.455.252a.98.98 0 0 1 .264.378c.057.145.085.301.085.47 0 .181-.03.348-.088.5a1.003 1.003 0 0 1-.267.39 1.26 1.26 0 0 1-.456.253c-.184.061-.402.091-.654.091h-.44V16H7.56v-3.643h1.285zm3.645 1.755h1.295v1.537a1.914 1.914 0 0 1-.596.297c-.211.062-.431.093-.662.093-.3 0-.572-.047-.818-.141a1.886 1.886 0 0 1-.632-.39 1.711 1.711 0 0 1-.405-.59 1.904 1.904 0 0 1-.142-.742c0-.271.045-.52.135-.748a1.686 1.686 0 0 1 .994-.974c.237-.092.503-.137.796-.137.152 0 .294.012.427.037.134.025.257.06.37.102a1.697 1.697 0 0 1 .558.35l-.245.373a.235.235 0 0 1-.149.107c-.06.014-.126-.001-.196-.045a2.626 2.626 0 0 0-.189-.103 1.152 1.152 0 0 0-.376-.111 1.913 1.913 0 0 0-.23-.013c-.158 0-.3.028-.428.084a.917.917 0 0 0-.323.236c-.09.102-.158.224-.207.366a1.476 1.476 0 0 0-.072.476c0 .194.027.365.08.516.053.15.129.276.226.38a.967.967 0 0 0 .35.236c.136.054.286.081.451.081.102 0 .194-.01.277-.03.082-.02.163-.047.241-.08v-.553h-.36a.175.175 0 0 1-.125-.042.142.142 0 0 1-.045-.107v-.465z"
      />
    </g>
  ),

  pdf: (
    <g fill="none" fillRule="evenodd">
      <path fill="#DA251C" d="M1 1h11.049v5.071H17V21H1z" />
      <path stroke="#FFF" strokeWidth="1.34" d="M11.667 1v5.333H17" />
      <path
        stroke="#DA251C"
        strokeLinecap="square"
        strokeWidth="1.34"
        d="M17 9V6.333L11.667 1H1v8"
      />

      <path
        stroke="#DA251C"
        strokeLinecap="square"
        strokeWidth="1.34"
        d="M1 8.333V21h16V8.333"
      />

      <path
        fill="#F5F6F7"
        stroke="#F5F6F7"
        strokeWidth="0.2"
        d="M5.82 14.145c.22 0 .378-.052.475-.157.097-.106.145-.252.145-.44a.658.658 0 0 0-.038-.228.463.463 0 0 0-.306-.29.851.851 0 0 0-.276-.04h-.44v1.155h.44zm0-1.787c.257 0 .477.03.661.09.184.062.336.145.455.252a.98.98 0 0 1 .264.378c.057.145.085.301.085.47 0 .181-.03.348-.088.5a1.003 1.003 0 0 1-.267.39 1.26 1.26 0 0 1-.456.253c-.184.061-.402.091-.654.091h-.44V16h-.845v-3.643H5.82zm5.2 1.82c0 .263-.045.506-.136.728-.091.223-.219.415-.384.578a1.74 1.74 0 0 1-.596.38A2.11 2.11 0 0 1 9.13 16H7.715v-3.643H9.13c.283 0 .541.046.774.138a1.692 1.692 0 0 1 .98.956c.09.223.136.465.136.726zm-.865 0c0-.18-.023-.343-.07-.488a1.042 1.042 0 0 0-.201-.369.874.874 0 0 0-.322-.232 1.09 1.09 0 0 0-.432-.082h-.565v2.343h.565c.162 0 .306-.027.433-.081a.874.874 0 0 0 .32-.233c.088-.1.155-.223.202-.368.047-.146.07-.309.07-.49zm2.215-1.17v.922h1.245v.652H12.37V16h-.85v-3.643h2.345v.65H12.37z"
      />
    </g>
  ),

  word: (
    <g>
      <path fill="#004A94" d="M1 1h11.049v5.071H17V21H1z" />
      <path stroke="#FFF" strokeWidth="1.34" d="M11.667 1v5.333H17" />
      <path
        stroke="#004A94"
        strokeLinecap="square"
        strokeWidth="1.34"
        d="M17 9V6.333L11.667 1H1v8"
      />

      <path
        stroke="#004A94"
        strokeLinecap="square"
        strokeWidth="1.34"
        d="M1 8.333V21h16V8.333"
      />

      <path
        fill="#F5F6F7"
        stroke="#F5F6F7"
        strokeWidth="0.2"
        d="M7.503 14.178c0 .263-.046.506-.137.728-.09.223-.218.415-.383.578a1.74 1.74 0 0 1-.597.38 2.11 2.11 0 0 1-.774.136H4.197v-3.643h1.415c.284 0 .542.046.774.138a1.692 1.692 0 0 1 .98.956c.091.223.136.465.136.726zm-.865 0c0-.18-.024-.343-.07-.488a1.042 1.042 0 0 0-.202-.369.874.874 0 0 0-.321-.232 1.09 1.09 0 0 0-.433-.082h-.564v2.343h.564c.162 0 .306-.027.433-.081a.874.874 0 0 0 .321-.233c.088-.1.155-.223.202-.368.046-.146.07-.309.07-.49zm4.94 0c0 .263-.046.508-.137.734-.09.227-.218.424-.384.592a1.76 1.76 0 0 1-.596.394c-.232.095-.49.142-.774.142-.283 0-.541-.047-.774-.142a1.77 1.77 0 0 1-.6-.394 1.762 1.762 0 0 1-.384-.591 1.958 1.958 0 0 1-.137-.736c0-.263.046-.508.137-.734.09-.227.219-.424.385-.59a1.78 1.78 0 0 1 .598-.393c.234-.095.492-.143.775-.143.284 0 .542.048.774.144.233.096.431.227.596.394.166.167.293.363.384.59.091.227.136.47.136.732zm-.865 0c0-.18-.024-.343-.07-.487a1.03 1.03 0 0 0-.202-.366.868.868 0 0 0-.321-.23 1.106 1.106 0 0 0-.432-.08c-.164 0-.31.027-.437.08a.866.866 0 0 0-.322.23 1.03 1.03 0 0 0-.201.366c-.047.144-.07.306-.07.486 0 .182.023.345.07.49.046.143.113.265.2.366.088.1.196.176.323.228.128.053.273.079.437.079.161 0 .305-.026.432-.079a.856.856 0 0 0 .321-.228c.088-.1.155-.223.202-.367.046-.144.07-.307.07-.489zm3.817.88c.02 0 .04.003.06.01.02.008.04.021.058.04l.335.352a1.39 1.39 0 0 1-.552.434c-.22.097-.482.146-.783.146-.277 0-.525-.047-.744-.141a1.61 1.61 0 0 1-.558-.39 1.717 1.717 0 0 1-.351-.59 2.179 2.179 0 0 1-.122-.742c0-.271.044-.52.132-.748a1.677 1.677 0 0 1 .947-.974c.224-.092.47-.137.738-.137a1.968 1.968 0 0 1 .725.136 1.547 1.547 0 0 1 .525.348l-.285.383a.363.363 0 0 1-.065.064.17.17 0 0 1-.105.028.188.188 0 0 1-.085-.02.94.94 0 0 1-.085-.048l-.099-.063a.758.758 0 0 0-.127-.062 1.054 1.054 0 0 0-.404-.069.932.932 0 0 0-.384.077.836.836 0 0 0-.3.227c-.084.099-.149.22-.195.365a1.629 1.629 0 0 0-.068.494c0 .186.025.352.076.497.05.145.12.267.207.366a.88.88 0 0 0 .681.304c.077 0 .147-.004.21-.011a.955.955 0 0 0 .178-.038.723.723 0 0 0 .155-.07.978.978 0 0 0 .148-.111.296.296 0 0 1 .064-.041.17.17 0 0 1 .073-.017z"
      />
    </g>
  ),

  cad: (
    <g>
      <path fill="#F1A208" d="M1 1h11.049v5.071H17V21H1z" />
      <path stroke="#FFF" strokeWidth="1.34" d="M11.667 1v5.333H17" />
      <path
        stroke="#F1A208"
        strokeLinecap="square"
        strokeWidth="1.34"
        d="M17 9V6.333L11.667 1H1v8"
      />

      <path
        stroke="#F1A208"
        strokeLinecap="square"
        strokeWidth="1.34"
        d="M1 8.333V21h16V8.333"
      />

      <path
        fill="#F5F6F7"
        stroke="#F5F6F7"
        strokeWidth="0.2"
        d="M7.17 15.057a.163.163 0 0 1 .117.05l.335.353a1.39 1.39 0 0 1-.55.434c-.222.097-.483.146-.785.146-.276 0-.524-.047-.743-.141a1.61 1.61 0 0 1-.558-.39 1.717 1.717 0 0 1-.351-.59 2.179 2.179 0 0 1-.122-.742c0-.271.044-.52.132-.748a1.677 1.677 0 0 1 .948-.974c.223-.092.469-.137.737-.137a1.968 1.968 0 0 1 .725.136 1.547 1.547 0 0 1 .525.348l-.285.383a.363.363 0 0 1-.065.064.17.17 0 0 1-.105.028.188.188 0 0 1-.085-.02.94.94 0 0 1-.085-.048l-.099-.063a.758.758 0 0 0-.127-.062 1.054 1.054 0 0 0-.404-.069.932.932 0 0 0-.384.077.836.836 0 0 0-.3.227c-.084.099-.149.22-.195.365a1.629 1.629 0 0 0-.068.494c0 .186.025.352.076.497.05.145.12.267.207.366a.88.88 0 0 0 .682.304c.076 0 .146-.004.21-.011a.955.955 0 0 0 .177-.038.723.723 0 0 0 .155-.07.978.978 0 0 0 .147-.111.296.296 0 0 1 .066-.041.17.17 0 0 1 .072-.017zm2.748-.45l-.338-.997a6.843 6.843 0 0 1-.165-.502 3.936 3.936 0 0 1-.16.507l-.335.992h.998zM11.26 16h-.655a.286.286 0 0 1-.178-.051.326.326 0 0 1-.102-.131l-.215-.636H8.725l-.215.636a.304.304 0 0 1-.099.126.276.276 0 0 1-.176.056h-.66l1.41-3.643h.865L11.26 16zm3.592-1.822c0 .263-.045.506-.136.728-.09.223-.218.415-.383.578a1.74 1.74 0 0 1-.597.38 2.11 2.11 0 0 1-.774.136h-1.415v-3.643h1.415c.284 0 .542.046.774.138a1.692 1.692 0 0 1 .98.956c.091.223.136.465.136.726zm-.864 0c0-.18-.024-.343-.07-.488a1.042 1.042 0 0 0-.202-.369.874.874 0 0 0-.321-.232 1.09 1.09 0 0 0-.432-.082h-.565v2.343h.565c.161 0 .305-.027.432-.081a.874.874 0 0 0 .321-.233c.088-.1.155-.223.202-.368.046-.146.07-.309.07-.49z"
      />
    </g>
  ),

  xls: (
    <g>
      <path fill="#1D7044" d="M1 1h11.049v5.071H17V21H1z" />
      <path stroke="#FFF" strokeWidth="1.34" d="M11.667 1v5.333H17" />
      <path
        stroke="#1D7044"
        strokeLinecap="square"
        strokeWidth="1.34"
        d="M17 9V6.333L11.667 1H1v8"
      />

      <path
        stroke="#1D7044"
        strokeLinecap="square"
        strokeWidth="1.34"
        d="M1 8.333V21h16V8.333"
      />

      <path
        fill="#F5F6F7"
        stroke="#F5F6F7"
        strokeWidth="0.2"
        d="M8.633 16h-.845a.211.211 0 0 1-.134-.04.305.305 0 0 1-.082-.095l-.73-1.275a.505.505 0 0 1-.044.095l-.68 1.18a.538.538 0 0 1-.083.092.177.177 0 0 1-.123.043h-.79l1.173-1.875-1.127-1.768h.845c.055 0 .095.008.12.022a.189.189 0 0 1 .07.071l.724 1.228a.532.532 0 0 1 .03-.063l.035-.063.636-1.09a.257.257 0 0 1 .073-.08.174.174 0 0 1 .097-.024h.81L7.465 14.09 8.633 16zm2.52-.675V16H8.957v-3.643h.845v2.968h1.35zm2.442-2.227a.317.317 0 0 1-.079.09.176.176 0 0 1-.106.03.26.26 0 0 1-.124-.037 22.623 22.623 0 0 0-.15-.081 1.245 1.245 0 0 0-.191-.081.765.765 0 0 0-.245-.037c-.158 0-.276.034-.354.102a.344.344 0 0 0-.116.274c0 .073.023.134.07.182.047.048.108.09.184.125s.162.067.26.096c.097.03.197.062.299.098.101.036.2.078.298.126.098.048.184.11.26.185a.863.863 0 0 1 .184.274c.047.107.07.237.07.388 0 .169-.03.326-.088.473a1.106 1.106 0 0 1-.663.641 1.534 1.534 0 0 1-.554.094c-.113 0-.229-.012-.346-.035a2.056 2.056 0 0 1-.652-.25 1.317 1.317 0 0 1-.252-.195l.25-.395a.25.25 0 0 1 .079-.071.205.205 0 0 1 .106-.029c.05 0 .1.016.151.048l.173.105c.064.038.138.073.221.105a.83.83 0 0 0 .295.047.562.562 0 0 0 .357-.101c.086-.068.128-.175.128-.321a.304.304 0 0 0-.07-.208.54.54 0 0 0-.184-.132 1.693 1.693 0 0 0-.258-.093 7.72 7.72 0 0 1-.298-.089 2.177 2.177 0 0 1-.297-.12.877.877 0 0 1-.443-.478 1.151 1.151 0 0 1-.07-.428 1.017 1.017 0 0 1 .325-.747c.107-.102.237-.183.393-.244a1.45 1.45 0 0 1 .532-.091c.112 0 .22.008.326.026a1.715 1.715 0 0 1 .568.2c.082.047.156.101.221.161l-.21.393z"
      />
    </g>
  ),

  file: (
    <g>
      <path fill="#1D7044" d="M1 1h11.049v5.071H17V21H1z" />
      <path stroke="#FFF" strokeWidth="1.34" d="M11.667 1v5.333H17" />
      <path
        stroke="#1D7044"
        strokeLinecap="square"
        strokeWidth="1.34"
        d="M17 9V6.333L11.667 1H1v8"
      />

      <path
        stroke="#1D7044"
        strokeLinecap="square"
        strokeWidth="1.34"
        d="M1 8.333V21h16V8.333"
      />
    </g>
  ),

  other: (
    <g>
      <path d="M13.174 10.74c0-.67.548-1.218 1.217-1.218V6.478c-.67 0-1.217-.548-1.217-1.217 0-.67.548-1.218 1.217-1.218v-.608A2.442 2.442 0 0 0 11.957 1H3.435A2.442 2.442 0 0 0 1 3.435v.608c.67 0 1.217.548 1.217 1.218 0 .67-.547 1.217-1.217 1.217v3.044c.67 0 1.217.548 1.217 1.217 0 .67-.547 1.218-1.217 1.218a2.442 2.442 0 0 0 2.435 2.434h8.522a2.442 2.442 0 0 0 2.434-2.434c-.67 0-1.217-.548-1.217-1.218z" />
      <path d="M4 4h2.435v2.435H4zM9 4h2.435v2.435H9zM4 9h2.435v2.435H4zM9 9h2.435v2.435H9z" />
    </g>
  ),

  options: (
    <g>
      <path d="M1.778 3.556A1.775 1.775 0 0 1 0 1.778C0 .794.794 0 1.778 0c.983 0 1.778.794 1.778 1.778 0 .983-.795 1.778-1.778 1.778zM7.704 3.556a1.775 1.775 0 0 1-1.778-1.778C5.926.794 6.72 0 7.704 0 8.687 0 9.48.794 9.48 1.778c0 .983-.794 1.778-1.777 1.778zM13.63 3.556a1.775 1.775 0 0 1-1.778-1.778C11.852.794 12.646 0 13.63 0c.983 0 1.777.794 1.777 1.778 0 .983-.794 1.778-1.777 1.778z" />
    </g>
  ),

  download: (
    <g fill="#888" fillRule="evenodd">
      <path d="M8 12c.3 0 .5-.1.7-.3L14.4 6 13 4.6l-4 4V0H7v8.6l-4-4L1.6 6l5.7 5.7c.2.2.4.3.7.3z" />
      <path d="M14 14H2v-3H0v4c0 .6.4 1 1 1h14c.6 0 1-.4 1-1v-4h-2v3z" />
    </g>
  ),

  info: (
    <g fill="#888" fillRule="evenodd" transform="translate(1 1)">
      <path strokeLinecap="square" strokeWidth="1.5" d="M1 3h3v6M0 9h6" />
      <circle cx="3.5" cy=".5" r="1" strokeLinecap="square" strokeWidth="1.5" />
      <circle cx="3.5" cy=".5" r="1" fillRule="nonzero" />
    </g>
  ),

  plusCircle: (
    <g fill="none" fillRule="evenodd">
      <circle cx="8" cy="8" r="7.467" fill="#1581BA" stroke="none" />
      <path
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 3.733v8.534M3.733 8h8.534"
      />
    </g>
  ),

  backward: (
    <g>
      <path
        fill="#000"
        fillRule="nonzero"
        d="M8.563 14.049c.434.446.434 1.17 0 1.616a1.09 1.09 0 0 1-1.57 0L.324 8.808a1.166 1.166 0 0 1 0-1.616L6.992.335a1.09 1.09 0 0 1 1.571 0c.434.446.434 1.17 0 1.616L2.683 8l5.88 6.049z"
      />
    </g>
  ),

  rightArrow: (
    <g transform="translate(2 4)">
      <path d="M5.889 1l4 3.5-4 3.5M9.889 4.5h-9" />
    </g>
  ),

  sort: (
    <g fill="#444444">
      <path d="M11 7h-6l3-4z" />
      <path d="M5 9h6l-3 4z" />
    </g>
  ),

  trash: (
    <g>
      <path d="M11.5.5l-11 11M.5.5l11 11" />
    </g>
  ),

  edit: (
    <g fill="#888" fillRule="evenodd">
      <path d="M8.1 3.5L.3 11.3c-.2.2-.3.4-.3.7v3c0 .6.4 1 1 1h3c.3 0 .5-.1.7-.3l7.8-7.8-4.4-4.4zM15.7 3.3l-3-3c-.4-.4-1-.4-1.4 0L9.5 2.1l4.4 4.4 1.8-1.8c.4-.4.4-1 0-1.4z" />
    </g>
  ),

  caretDown: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="5"
      viewBox="0 0 9 5"
    >
      <path
        fill="#888"
        fillRule="nonzero"
        d="M7.903.183a.656.656 0 0 1 .909 0 .613.613 0 0 1 0 .884l-3.857 3.75a.656.656 0 0 1-.91 0L.188 1.067a.613.613 0 0 1 0-.884.656.656 0 0 1 .91 0L4.5 3.491 7.903.183z"
      />
    </svg>
  ),

  caretUp: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="5"
      viewBox="0 0 9 5"
    >
      <path
        fill="#888"
        fillRule="nonzero"
        d="M7.903 4.817a.656.656 0 0 0 .909 0 .613.613 0 0 0 0-.884L4.955.183a.656.656 0 0 0-.91 0L.188 3.933a.613.613 0 0 0 0 .884.656.656 0 0 0 .91 0L4.5 1.509l3.403 3.308z"
      />
    </svg>
  ),

  hollowPlusCircle: (
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      transform="translate(1.421 1)"
    >
      <circle cx="6" cy="6" r="6" strokeWidth="1.071" />
      <path d="M6 3v6M3 6h6" />
    </g>
  ),

  navForward: (
    <g>
      <path
        fill="#989CA6"
        fillRule="nonzero"
        d="M.655 14.493a1.166 1.166 0 0 0 0 1.617 1.09 1.09 0 0 0 1.571 0l6.667-6.857a1.166 1.166 0 0 0 0-1.617L2.226.78a1.09 1.09 0 0 0-1.571 0 1.166 1.166 0 0 0 0 1.616l5.881 6.05-5.881 6.048z"
      />
    </g>
  ),

  hide: (
    <g xmlns="http://www.w3.org/2000/svg" width="22" height="20">
      <path
        fill="#888"
        fillRule="nonzero"
        d="M6.63 10.266a.908.908 0 0 0 0 1.286l3.636 3.636c.171.17.402.266.643.267a.918.918 0 0 0 .643-.267l3.636-3.636a.909.909 0 1 0-1.285-1.286l-2.085 2.085V.909A.91.91 0 1 0 10 .91v11.442l-2.085-2.085a.908.908 0 0 0-1.285 0zM19.09 0h-4.545a.91.91 0 0 0 0 1.818h4.546c.5 0 .909.408.909.91v2.727h-5.455a.91.91 0 0 0 0 1.818H20v10c0 .5-.408.909-.91.909H2.728a.91.91 0 0 1-.909-.91v-10h5.455a.91.91 0 1 0 0-1.817H1.818V2.727c0-.5.408-.909.91-.909h4.545a.91.91 0 0 0 0-1.818H2.727A2.73 2.73 0 0 0 0 2.727v14.546A2.73 2.73 0 0 0 2.727 20h16.364a2.73 2.73 0 0 0 2.727-2.727V2.727A2.73 2.73 0 0 0 19.091 0z"
      />
    </g>
  ),

  link: (
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#888"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M7.396 6c1.1 1.1 1.1 2.88 0 3.98l-1.592 1.592a2.814 2.814 0 1 1-3.98-3.98l1.399-1.358" />
      <path d="M5.71 6.51a2.424 2.424 0 0 1 0-3.428L7.082 1.71A2.424 2.424 0 1 1 10.51 5.14l-1.205 1.17" />
    </g>
  ),

  arrowRight: (
    <g>
      <path
        fill="#989CA6"
        fillRule="nonzero"
        d="M.83 14.549c-.44.446-.44 1.17 0 1.616.439.447 1.151.447 1.59 0l6.75-6.857c.44-.446.44-1.17 0-1.616L2.42.835a1.113 1.113 0 0 0-1.59 0c-.44.446-.44 1.17 0 1.616L6.784 8.5.83 14.549z"
      />
    </g>
  )
};

const getSVG = (icon: string) => svgs[icon];

export default getSVG;
